import { REDUX_ACTIONS } from '../../shared/config/constants';

const initialState = {
  loading: false,
  errorMessage: '',
  data: [],
};

const wellboreImportReducer = (state = initialState, action) => {
  switch (action.type) {
    case REDUX_ACTIONS.WELLBORE_MUDPROFILE_LIST_LOADING:
      return {
        ...state,
        loading: true,
        errorMessage: '',
      };

    case REDUX_ACTIONS.WELLBORE_MUDPROFILE_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        data: [...action.payload.data],
        errorMessage: '',
      };

    case REDUX_ACTIONS.WELLBORE_MUDPROFILE_LIST_ERROR:
      return {
        ...state,
        loading: false,
        errorMessage: action.payload.message,
        data: [],
      };
    case REDUX_ACTIONS.WELLBORE_MUDPROFILE_RESET:
      return {
        ...initialState,
      };
    default:
      return state;
  }
};

export default wellboreImportReducer;
